module.exports = __webpack_public_path__ + "img/avatar.5a021ab9.png";